module.exports = __webpack_public_path__ + "img/reception2.c6929cbb.png";